let instance = null;


class LocalStorageManager {
    constructor() {
        instance = instance || this
        return instance
    }

    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        } catch (error) {
            console.error("Error setting data in localStorage:", error);
            return false;
        }
    }

    get(key) {
        try {
            const storedValue = localStorage.getItem(key);

            // If the key is not found, return null
            if (!storedValue) {
                return storedValue;
            }

            // Try parsing the stored value
            try {
                const parsedValue = JSON.parse(storedValue);
                // Return the parsed value with the correct data type
                return parsedValue;
            } catch (parseError) {
                // If parsing fails, return the raw string value
                return storedValue;
            }
        } catch (error) {
            console.error("Error getting data from localStorage:", error);
            return null;
        }
    }

    delete(key) {
        try {
            localStorage.removeItem(key);
            return true;
        } catch (error) {
            console.error("Error deleting data from localStorage:", error);
            return false;
        }
    }
}

export default new LocalStorageManager()